// hover-menu.js
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("header-menu details").forEach(function (menu) {
    var closeTimer = null;
    var summary = menu.querySelector("summary");
    var submenu = menu.querySelector(".header__submenu");

    function openMenu() {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
      if (!menu.hasAttribute("open")) menu.setAttribute("open", "");
    }

    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        if (menu.hasAttribute("open")) menu.removeAttribute("open");
      }, 180); // delay in ms — increase to 250 if needed
    }

    // Keep open while pointer is anywhere on the details, its summary or submenu
    menu.addEventListener("mouseenter", openMenu);
    menu.addEventListener("mouseleave", scheduleClose);

    if (summary) {
      summary.addEventListener("mouseenter", openMenu);
      summary.addEventListener("mouseleave", scheduleClose);
    }

    if (submenu) {
      submenu.addEventListener("mouseenter", openMenu);
      submenu.addEventListener("mouseleave", scheduleClose);

      // Stop clicks in submenu from bubbling and accidentally closing the menu
      submenu.addEventListener("click", function (e) {
        e.stopPropagation();
      });
    }

    // Mobile/touch: first tap opens the menu (prevent instant nav), second tap follows link
    menu.addEventListener("touchstart", function (e) {
      if (!menu.hasAttribute("open")) {
        // prevent the first tap from navigating/closing — open instead
        e.preventDefault();
        openMenu();
      }
      // If already open, allow the default tap behavior
    });
  });
});
